import { render, staticRenderFns } from "./PinABug.vue?vue&type=template&id=12b4557a&scoped=true&"
import script from "./PinABug.vue?vue&type=script&lang=js&"
export * from "./PinABug.vue?vue&type=script&lang=js&"
import style0 from "./PinABug.vue?vue&type=style&index=0&id=12b4557a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4557a",
  null
  
)

export default component.exports